/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  pure: false,
})
export class PhonePipe implements PipeTransform {
  public transform(val: string): string {
    if (val) {
      let viewVal = val.trim().replace(/^\+/, '');
      viewVal = viewVal.replace(/[^0-9]/g, '').slice(-10);
      let len = viewVal.length;
      if (len > 6) {
        return '(' + viewVal.slice(0, 3) + ') ' + viewVal.slice(3, 6) + '-' + viewVal.slice(6);
      } else if (len > 3) {
        return '(' + viewVal.slice(0, 3) + ') ' + viewVal.slice(3, 6);
      } else {
        return viewVal;
      }
    }
    return '';
  }
}
